/* Byteful · premium hareketler: kreatif vitrin, telefon sahnesi, bildirimler, büyüme paneli */
(function () {
  'use strict';

  if (window.__bdMotion) return;
  window.__bdMotion = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var small = window.matchMedia('(max-width: 749px)');

  function motionOK() {
    return !reduced.matches && !root.classList.contains('bd-motion-off');
  }
  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function autoplayOK() {
    return motionOK() && !saveData();
  }
  function define(name, ctor) {
    if (!window.customElements.get(name)) window.customElements.define(name, ctor);
  }
  function track(name, data) {
    var payload = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) { /* analitik isteğe bağlıdır */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (error) { /* yok say */ }
  }

  /* ---------------------------------------------------------------
     Video yardımcıları
     --------------------------------------------------------------- */
  function loadVideo(video, hd) {
    if (!video) return false;
    var src = hd ? (video.dataset.srcHd || video.dataset.src) : (video.dataset.src || video.dataset.srcHd);
    if (!src) return false;
    if (video.dataset.loaded !== src) {
      video.src = src;
      video.dataset.loaded = src;
    }
    return true;
  }
  function safePlay(video) {
    try {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    } catch (error) { /* oynatılamadı */ }
  }

  /* ---------------------------------------------------------------
     Kaydırma ilerleme çizgisi
     --------------------------------------------------------------- */
  var progress = document.querySelector('.bd-progress');
  if (progress) {
    var ticking = false;
    var updateProgress = function () {
      ticking = false;
      var max = root.scrollHeight - window.innerHeight;
      progress.style.setProperty('--p', max > 0 ? Math.min(1, window.scrollY / max).toFixed(4) : '0');
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  /* ---------------------------------------------------------------
     Kartlarda fareyi izleyen ışık
     --------------------------------------------------------------- */
  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !event.target.closest) return;
    var el = event.target.closest('[data-spotlight]');
    if (!el) return;
    var rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', (event.clientX - rect.left).toFixed(0) + 'px');
    el.style.setProperty('--my', (event.clientY - rect.top).toFixed(0) + 'px');
  }, { passive: true });

  /* ---------------------------------------------------------------
     Mıknatıs etkili ana butonlar (yalnızca fare ile)
     --------------------------------------------------------------- */
  function magnetic(button) {
    if (button.dataset.magnetic) return;
    button.dataset.magnetic = '1';
    var rect = null;
    button.addEventListener('pointerenter', function () { rect = button.getBoundingClientRect(); });
    button.addEventListener('pointermove', function (event) {
      if (!rect || event.pointerType !== 'mouse' || !motionOK()) return;
      var x = (event.clientX - rect.left - rect.width / 2) * 0.14;
      var y = (event.clientY - rect.top - rect.height / 2) * 0.26;
      button.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px)';
    });
    button.addEventListener('pointerleave', function () {
      rect = null;
      button.style.transform = '';
    });
  }
  function initMagnetic(scope) {
    if (!finePointer.matches) return;
    (scope || document).querySelectorAll('.bd-btn--accent').forEach(magnetic);
  }

  /* ---------------------------------------------------------------
     Telefon sahnesi: reklam videoları sırayla oynar
     --------------------------------------------------------------- */
  class BdPhoneFeed extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.bd-phone__slide'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.bd-phone__bars i'));
      this.brand = this.querySelector('[data-phone-brand]');
      this.interval = parseFloat(this.dataset.interval) || 7000;
      this.index = 0;
      this.remaining = 0;
      this.style.setProperty('--dur', this.interval + 'ms');
      if (!this.slides.length) return;
      if (!autoplayOK() || !('IntersectionObserver' in window)) {
        this.classList.add('is-static');
        return;
      }
      this.io = new IntersectionObserver(function (entries) {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !document.hidden) this.play();
        else this.pause();
      }.bind(this), { threshold: 0.2 });
      this.io.observe(this);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) this.pause();
        else if (this.visible) this.play();
      }.bind(this));
    }

    videoAt(i) {
      return this.slides[i] ? this.slides[i].querySelector('video') : null;
    }

    setBars() {
      this.bars.forEach(function (bar, n) {
        bar.classList.toggle('is-done', n < this.index);
        if (n === this.index) {
          if (!bar.classList.contains('is-active')) {
            void bar.offsetWidth;
            bar.classList.add('is-active');
          }
        } else {
          bar.classList.remove('is-active');
        }
      }.bind(this));
    }

    play() {
      if (this.playing) return;
      this.playing = true;
      var video = this.videoAt(this.index);
      if (loadVideo(video, false)) safePlay(video);
      this.slides[this.index].classList.add('is-active');
      this.setBars();
      this.classList.remove('is-paused');
      window.clearTimeout(this.timer);
      this.startedAt = performance.now();
      var wait = this.remaining || this.interval;
      this.timer = window.setTimeout(this.next.bind(this), wait);
      this.remaining = 0;
      var nextVideo = this.videoAt((this.index + 1) % this.slides.length);
      if (nextVideo && nextVideo !== video) {
        window.clearTimeout(this.preloadTimer);
        this.preloadTimer = window.setTimeout(function () {
          if (loadVideo(nextVideo, false)) nextVideo.preload = 'auto';
        }, Math.max(0, wait - 2500));
      }
    }

    pause() {
      if (!this.playing) return;
      this.playing = false;
      window.clearTimeout(this.timer);
      window.clearTimeout(this.preloadTimer);
      if (this.startedAt) this.remaining = Math.max(900, this.interval - (performance.now() - this.startedAt));
      var video = this.videoAt(this.index);
      if (video) video.pause();
      this.classList.add('is-paused');
    }

    next() {
      var prev = this.index;
      var prevSlide = this.slides[prev];
      var prevVideo = this.videoAt(prev);
      this.index = (this.index + 1) % this.slides.length;
      if (this.index === 0) this.bars.forEach(function (bar) { bar.classList.remove('is-done', 'is-active'); });
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add('is-leaving');
      window.setTimeout(function () {
        prevSlide.classList.remove('is-leaving');
        if (prevVideo && !prevSlide.classList.contains('is-active')) {
          prevVideo.pause();
          try { prevVideo.currentTime = 0; } catch (error) { /* yok say */ }
        }
      }, 900);
      var name = this.slides[this.index].dataset.brand;
      if (this.brand && name) this.brand.textContent = name;
      this.playing = false;
      this.remaining = 0;
      this.play();
    }
  }

  /* ---------------------------------------------------------------
     Bildirim yığını: kartlar yukarıdan gelir, eskiler aşağıda solar
     --------------------------------------------------------------- */
  class BdNotifyStack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.items = Array.prototype.slice.call(this.querySelectorAll('.bd-note'));
      if (!this.items.length) return;
      this.visibleCount = parseInt(this.dataset.visible, 10) || (small.matches ? 2 : 3);
      this.liveTime = this.dataset.liveTime !== 'false';
      this.timeLabels = ['şimdi', '1 dk önce', '3 dk önce', '6 dk önce', '9 dk önce'];
      this.interval = parseFloat(this.dataset.interval) || 2600;
      this.shown = [];
      this.cursor = 0;
      this.classList.add('is-ready');
      this.items.forEach(function (el) { el.classList.add('is-queued'); });

      if (!motionOK() || !('IntersectionObserver' in window)) {
        for (var i = 0; i < Math.min(this.visibleCount, this.items.length); i++) this.push(true);
        return;
      }
      this.push(true);
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) this.start();
        else this.stop();
      }.bind(this), { threshold: 0.15 });
      this.io.observe(this);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) this.stop();
      }.bind(this));
      window.addEventListener('resize', function () { this.layout(); }.bind(this), { passive: true });
    }

    start() {
      if (this.running) return;
      this.running = true;
      this.timer = window.setInterval(function () { this.push(false); }.bind(this), this.interval);
    }

    stop() {
      this.running = false;
      window.clearInterval(this.timer);
    }

    push(instant) {
      var el = this.items[this.cursor % this.items.length];
      this.cursor += 1;
      var existing = this.shown.indexOf(el);
      if (existing > -1) this.shown.splice(existing, 1);
      el.classList.remove('is-queued', 'is-leaving');
      if (!instant) {
        el.classList.add('is-entering', 'is-new');
        void el.offsetWidth;
        window.clearTimeout(el._newTimer);
        el._newTimer = window.setTimeout(function () { el.classList.remove('is-new'); }, 1000);
      }
      this.shown.unshift(el);
      el.classList.remove('is-entering');
      if (this.shown.length > this.visibleCount) {
        var old = this.shown.pop();
        old.classList.add('is-leaving');
        window.setTimeout(function () {
          if (this.shown.indexOf(old) === -1) {
            old.classList.remove('is-leaving');
            old.classList.add('is-queued');
          }
        }.bind(this), 700);
      }
      this.layout();
    }

    layout() {
      var y = 0;
      var labels = this.timeLabels;
      var live = this.liveTime;
      this.shown.forEach(function (el, i) {
        if (live) {
          var t = el.querySelector('.bd-note__meta i');
          if (t) t.textContent = labels[Math.min(i, labels.length - 1)];
        }
        el.style.setProperty('--i', i);
        el.style.setProperty('--y', y + 'px');
        y += el.offsetHeight + 10;
      });
      this.style.setProperty('--stack-h', Math.max(0, y - 10) + 'px');
    }
  }

  /* ---------------------------------------------------------------
     Kreatif vitrin: görünen videolar sessiz oynar, dokununca sesli izlenir
     --------------------------------------------------------------- */
  class BdReels extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.section = this.closest('.bd-reels') || this.parentElement;
      this.list = this.querySelector('[data-reel-list]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.bd-reel'));
      this.maxPlay = parseInt(this.dataset.maxPlay, 10) || 2;
      if (small.matches) this.maxPlay = 1;
      this.autoplay = this.dataset.autoplay !== 'false' && autoplayOK();
      this.ratios = new Map();
      this.lightbox = this.section.querySelector('[data-lightbox]');
      this.filters = Array.prototype.slice.call(this.section.querySelectorAll('[data-reel-filter]'));
      this.prevBtn = this.section.querySelector('[data-reel-prev]');
      this.nextBtn = this.section.querySelector('[data-reel-next]');

      this.cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        video.addEventListener('playing', function () { card.classList.add('is-playing'); });
        video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      });

      this.endTile = this.querySelector('[data-reel-end]');

      this.bindFilters();
      this.bindNav();
      this.bindOpen();
      this.bindLightbox();
      this.fitEnd();
      if (this.endTile) {
        window.addEventListener('resize', function () {
          window.clearTimeout(this.fitTimer);
          this.fitTimer = window.setTimeout(this.fitEnd.bind(this), 120);
        }.bind(this), { passive: true });
      }

      if (this.autoplay && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 0.3, 0.6, 0.9] });
        this.cards.forEach(function (card) { this.io.observe(card); }.bind(this));
        document.addEventListener('visibilitychange', this.schedule.bind(this));
      } else if (finePointer.matches && motionOK() && !saveData()) {
        this.cards.forEach(function (card) {
          var video = card.querySelector('video');
          card.addEventListener('pointerenter', function () { if (loadVideo(video, false)) safePlay(video); });
          card.addEventListener('pointerleave', function () { video.pause(); });
        });
      }
    }

    onIntersect(entries) {
      entries.forEach(function (entry) {
        this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      }.bind(this));
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.scheduleTimer);
      this.scheduleTimer = window.setTimeout(this.apply.bind(this), 140);
    }

    apply() {
      if (!this.autoplay) return;
      var blocked = document.hidden || (this.lightbox && this.lightbox.open);
      var ratios = this.ratios;
      var cards = this.cards;
      var picks = blocked ? [] : cards.filter(function (card) {
        return !card.hidden && (ratios.get(card) || 0) >= 0.6;
      }).sort(function (a, b) {
        return (ratios.get(b) - ratios.get(a)) || (cards.indexOf(a) - cards.indexOf(b));
      }).slice(0, this.maxPlay);
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        if (picks.indexOf(card) > -1) {
          video.muted = true;
          if (loadVideo(video, false)) safePlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    visibleCards() {
      return this.cards.filter(function (card) { return !card.hidden; });
    }

    /* Izgarada kapanış kartı son satırdaki boşluğu doldurur */
    fitEnd() {
      var end = this.endTile;
      if (!end || !this.list) return;
      var style = window.getComputedStyle(this.list);
      if (style.display !== 'grid') {
        end.style.removeProperty('grid-column');
        end.removeAttribute('data-span');
        return;
      }
      var cols = style.gridTemplateColumns.split(' ').filter(function (v) { return v && v !== 'none'; }).length || 1;
      var rest = this.visibleCards().length % cols;
      var span = rest === 0 ? cols : cols - rest;
      end.style.gridColumn = 'span ' + span;
      end.setAttribute('data-span', span === cols ? 'full' : String(span));
    }

    bindFilters() {
      var self = this;
      this.filters.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.dataset.reelFilter;
          self.filters.forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
          self.classList.add('is-filtering');
          window.setTimeout(function () {
            self.cards.forEach(function (card) {
              card.hidden = value !== 'all' && card.dataset.cat !== value;
              if (card.hidden) {
                var video = card.querySelector('video');
                if (video) video.pause();
              }
            });
            if (self.list) self.list.scrollLeft = 0;
            self.fitEnd();
            self.classList.remove('is-filtering');
            self.updateNav();
            self.schedule();
          }, motionOK() ? 220 : 0);
          track('byteful_reel_filter', { category: value });
        });
      });
    }

    bindNav() {
      if (!this.list) return;
      var self = this;
      function step(direction) {
        var amount = Math.max(260, self.list.clientWidth * 0.8);
        self.list.scrollBy({ left: direction * amount, behavior: motionOK() ? 'smooth' : 'auto' });
      }
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { step(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { step(1); });
      this.list.addEventListener('scroll', function () {
        window.clearTimeout(self.navTimer);
        self.navTimer = window.setTimeout(function () { self.updateNav(); }, 90);
      }, { passive: true });
      window.addEventListener('resize', function () { self.updateNav(); }, { passive: true });
      this.updateNav();
    }

    updateNav() {
      if (!this.list || !this.prevBtn || !this.nextBtn) return;
      var max = this.list.scrollWidth - this.list.clientWidth - 4;
      this.prevBtn.disabled = this.list.scrollLeft <= 4;
      this.nextBtn.disabled = this.list.scrollLeft >= max;
    }

    bindOpen() {
      var self = this;
      this.cards.forEach(function (card) {
        var button = card.querySelector('[data-reel-open]');
        if (!button) return;
        button.addEventListener('click', function () {
          var visible = self.visibleCards();
          self.open(visible.indexOf(card));
        });
      });
    }

    bindLightbox() {
      var box = this.lightbox;
      if (!box) return;
      var self = this;
      this.lbVideo = box.querySelector('[data-lb-video]');
      this.lbBrand = box.querySelector('[data-lb-brand]');
      this.lbCaption = box.querySelector('[data-lb-caption]');
      this.lbCount = box.querySelector('[data-lb-count]');
      box.querySelector('[data-lb-close]').addEventListener('click', function () { box.close(); });
      box.querySelector('[data-lb-prev]').addEventListener('click', function () { self.go(-1); });
      box.querySelector('[data-lb-next]').addEventListener('click', function () { self.go(1); });
      box.addEventListener('click', function (event) {
        if (event.target === box) box.close();
      });
      box.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); self.go(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); self.go(-1); }
      });
      box.addEventListener('close', function () {
        if (self.lbVideo) {
          self.lbVideo.pause();
          self.lbVideo.removeAttribute('src');
          self.lbVideo.load();
        }
        document.body.classList.remove('bd-locked');
        if (self.lastTrigger) self.lastTrigger.focus({ preventScroll: true });
        self.schedule();
      });
      if (this.lbVideo) {
        this.lbVideo.addEventListener('ended', function () { self.go(1); });
      }
      var startX = 0;
      var startY = 0;
      box.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      box.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
        else if (dy > 110 && Math.abs(dy) > Math.abs(dx)) box.close();
      }, { passive: true });
    }

    open(index) {
      var box = this.lightbox;
      if (!box || index < 0) return;
      this.cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (video) video.pause();
      });
      this.current = index;
      this.lastTrigger = document.activeElement;
      if (!box.open) {
        if (typeof box.showModal === 'function') box.showModal();
        else box.setAttribute('open', '');
      }
      document.body.classList.add('bd-locked');
      this.show();
    }

    go(direction) {
      var list = this.visibleCards();
      if (!list.length) return;
      this.current = (this.current + direction + list.length) % list.length;
      this.show();
    }

    show() {
      var list = this.visibleCards();
      var card = list[this.current];
      if (!card || !this.lbVideo) return;
      var source = card.querySelector('video');
      var src = source.dataset.srcHd || source.dataset.src;
      if (!src) return;
      this.lbVideo.poster = source.getAttribute('poster') || '';
      this.lbVideo.src = src;
      this.lbVideo.muted = false;
      var volume = parseFloat(source.dataset.volume);
      this.lbVideo.volume = isNaN(volume) ? 1 : Math.min(1, Math.max(0.05, volume / 100));
      safePlay(this.lbVideo);
      if (this.lbBrand) this.lbBrand.textContent = source.dataset.brand || source.dataset.catLabel || '';
      if (this.lbCaption) this.lbCaption.textContent = source.dataset.caption || '';
      if (this.lbCount) this.lbCount.textContent = (this.current + 1) + ' / ' + list.length;
      track('byteful_reel_play', { brand: source.dataset.brand || '', category: card.dataset.cat || '' });
    }
  }

  /* ---------------------------------------------------------------
     Büyüme paneli: göstergeler sayar, grafik çizilir
     --------------------------------------------------------------- */
  var trInt = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
  var trDec1 = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  function formatKpi(value, format) {
    if (format === 'currency') return '₺' + trInt.format(value);
    if (format === 'x') return trDec1.format(value) + 'x';
    if (format === 'percent') return '%' + trInt.format(value);
    return trInt.format(value);
  }

  class BdGrowthPanel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.kpis = Array.prototype.slice.call(this.querySelectorAll('[data-kpi]'));
      if (!motionOK() || !('IntersectionObserver' in window)) {
        this.classList.add('is-live', 'is-instant');
        return;
      }
      this.kpis.forEach(function (el) {
        var target = parseFloat(String(el.dataset.kpi).replace(',', '.'));
        if (!isNaN(target)) el.textContent = formatKpi(0, el.dataset.format);
      });
      this.io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        this.io.disconnect();
        this.classList.add('is-live');
        this.count();
      }.bind(this), { threshold: 0.35 });
      this.io.observe(this);
    }

    count() {
      var start = performance.now();
      var duration = 1800;
      var kpis = this.kpis;
      function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 4);
        kpis.forEach(function (el) {
          var target = parseFloat(String(el.dataset.kpi).replace(',', '.'));
          if (isNaN(target)) return;
          el.textContent = formatKpi(target * eased, el.dataset.format);
        });
        if (t < 1) window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
    }
  }

  define('bd-phone-feed', BdPhoneFeed);
  define('bd-notify-stack', BdNotifyStack);
  define('bd-reels', BdReels);
  define('bd-growth-panel', BdGrowthPanel);

  /* Açılış başlığını kelimelere böler, kelimeler sırayla belirir */
  function splitWords(el) {
    if (!el || el.classList.contains('is-split')) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var index = 0;
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var word = document.createElement('span');
        word.className = 'bd-w';
        word.textContent = part;
        word.style.setProperty('--wi', index);
        index += 1;
        frag.appendChild(word);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('is-split');
  }

  function init() {
    initMagnetic(document);
    if (motionOK() && !document.body.classList.contains('bd-design-mode')) {
      Array.prototype.forEach.call(document.querySelectorAll('.bd-hero__title[data-split]'), splitWords);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    initMagnetic(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest && event.target.closest('.bd-reel');
    if (card && card.parentElement) {
      card.parentElement.scrollTo({ left: card.offsetLeft - 20, behavior: 'smooth' });
    }
  });
})();
